export default "__VITE_ASSET__895d985b__"